import React, { useEffect, useState } from "react";
import { getCurrentMode, getGirdColumns, getGirdRows, videoLayoutMode } from "../..";
import { getLocalParticipantId, getSortedLayoutParticipant, ParticipantView } from "../../../base/participants";
import { connect } from "../../../base/redux";
import { LayoutContainerStyled, StyledLayoutContainer } from "../../styled";


function DualMonitorContainer({ 
    outerWidth, outerHeight, participants, localId
}) {
    const [gridStyle, setGridStyle] = useState();

    useEffect(() => {
        const count = participants.length;
        const columns = getGirdColumns(count);
        const rows = getGirdRows(count);
        
        if (document.getElementsByClassName("arrow")?.length > 0) {
            outerWidth = outerWidth - 60;
        };

        outerWidth = outerWidth / columns;
        outerHeight = outerHeight / rows;
        
        let width = outerWidth;
        let height = ((9 * width) / 16);

        if ((Math.floor(outerHeight/height) < rows) && (outerHeight < height)) {
            height = outerHeight;
            width = ((16 * height) / 9) ;
        }

        setGridStyle({width: `${width}px`, height: `${height}px`});
    }, [participants.length, outerWidth, outerHeight]);
    

    return (
        <LayoutContainerStyled 
            isDocument={false}
            isGrid={true}
            className="layout_wrapper"
            style={{ width: "100%", height: "100%", flexFlow: "wrap"}}>
            { participants.map((participantId, index) => {        
                const isLocal = localId === participantId;
                
                return (                               
                    <StyledLayoutContainer
                        key={index}
                        isLocal={isLocal}
                        id={participantId}
                        className={`item item_${isLocal}` }
                        style={gridStyle}
                    > 
                        <ParticipantView 
                            participantId={participantId}
                        />
                    </StyledLayoutContainer>
                )
            })}
        </LayoutContainerStyled>
    )
}

function _mapStateToProps(state) {
    const mode = getCurrentMode(state);

    let pinnedParticipants = new Set();
    // 나 자신 
    const localParticipantId = getLocalParticipantId(state);

    let includePin = mode === videoLayoutMode.pin || mode === videoLayoutMode.voice ? false : true;

    // 레이아웃에 보일 사용자 
    const participants = new Set(getSortedLayoutParticipant(state, includePin).map(p => p.user_uuid));
    
    if (videoLayoutMode.grid === mode) {
        const { hostParticipant } = state['features/base/participants'];
        [...hostParticipant].map(h => {
            if (participants.has(h)) participants.delete(h);
        });        
    } else if (videoLayoutMode.voice === mode) {
        const dominantSpeaker = state['features/base/participants'].dominantSpeaker;
        if (participants.has(dominantSpeaker)) participants.delete(dominantSpeaker);
    }
    
    return {
        mode, 
        participants: [...participants],
        localId: localParticipantId
    }
}

export default connect(_mapStateToProps)(DualMonitorContainer);